import { render, staticRenderFns } from "./CustomerContactPrint.vue?vue&type=template&id=07c64a28"
import script from "./CustomerContactPrint.vue?vue&type=script&lang=js"
export * from "./CustomerContactPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports